import { IEventItem } from '../../../../store/player/events/store';

export const sorting = [
  {
    callback: (a: IEventItem, b: IEventItem) => {
      return a.start < b.start ? -1 : a.start > b.start ? 1 : 0;
    },
    label: 'UPCOMING'
  },
  {
    callback: (a: IEventItem, b: IEventItem) => {
      return a.start < b.start ? 1 : a.start > b.start ? -1 : 0;
    },
    label: 'COMPLETED'
  }
];
